// FilePreviewProvider.js
import Vue from 'vue'
import URL from 'url'
// import router from '../router'

export const FilePreviewProvider = new Vue({
    methods: {
        getExt (src) {
            // eslint-disable-next-line node/no-deprecated-api
            let path = URL.parse(src).pathname
            return path.substring(path.lastIndexOf('.') + 1)
        },
        toPreview (src) {
            let ext = this.getExt(src)
            let pathComponent = encodeURIComponent(src)
            if (['doc', 'docx', 'xls', 'xlsx'].includes(ext)) {
                window.open(
                    `https://view.officeapps.live.com/op/view.aspx?src=${pathComponent}`
                )
            } else if (['pdf'].includes(ext)) {
                // let routeData = router.resolve({
                //     path: '/view',
                //     query: {
                //         path: pathComponent
                //     }
                // })
                // window.open(routeData.href, '_blank')
                window.open(src)
            } else if (['jpg', 'png', 'gif', 'bmp', 'jpeg', 'webp'].includes(ext)) {
                this.$eventBus.$emit('showPhotoViewer', src)
            } else {
                window.open(src)
            }
        }
    }
})
